import { Box, Expandable, InputSelect, Stack } from '@sparky';
import { styled } from '@sparky/stitches';

export const AdviceCardImageContainer = styled(Box, {
  lineHeight: '0',
});

export const SentenceContainer = styled(Stack, {
  fontSize: '$fontSizes$18',
  fontWeight: '$headingRegular',
  '@md': {
    fontSize: '$fontSizes$24',
  },
});

export const StyledInputSelect = styled(InputSelect, {
  backgroundColor: 'transparent',
  border: 'none',
  borderBottom: '2px solid $textHighlightVarFour',
  borderRadius: '0',
  borderTop: '2px solid transparent',
  color: '$textHighlightVarFour',
  fontSize: '$fontSizes$18',
  fontWeight: '$headingRegular',
  minHeight: 'auto',
  paddingBottom: '$space$2',
  paddingLeft: '0',
  paddingRight: '$space$8',
  paddingTop: '0',
  '+ div': {
    padding: '0',
    '> svg': {
      fill: '$textHighlightVarFour',
      marginTop: '-$space$3',
    },
  },
  '&:hover, &:focus': {
    borderTopColor: 'transparent !important',
  },
  '@md': {
    fontSize: '$fontSizes$24',
    paddingLeft: '$space$1',
  },
});

export const TipCardContainer = styled(Box, {
  minHeight: '300px',
});

export const Trigger = styled(Expandable.Trigger, {
  alignItems: 'flex-start',
  minHeight: '$space$16',
});

AdviceCardImageContainer.displayName = 'AdviceCardImageContainer';
SentenceContainer.displayName = 'SentenceContainer';
StyledInputSelect.displayName = 'StyledInputSelect';
TipCardContainer.displayName = 'TipCardContainer';
Trigger.displayName = 'LoaderContainer';
